<template>
    <div>
        <v-card class="score-parent2 ma-1">
            <v-container>
                <v-card flat class="score-text" min-height="150 ma-0 pa-0">
                    <div class="flex-col">
                        <v-avatar class="score" :size="getSize()">
                            <div class="badge">
                                <div>Average score</div>
                                <div>based on <span class="nrofreviews-font">{{reviews.total_reviews_pub}}</span> reviews</div>
                                <div :class="{'av-font': getSize()===295, 'av-font-xl': getSize()!==295}" class="font-weight-bold">{{ reviews.total_average_score_pub }}</div>
                                <div :class="{'small-font': getSize()===295, 'small-font': getSize()!==295}">({{ reviews.exact_total_average_pub }})</div>
                            </div>
                        </v-avatar>
                    </div>
                </v-card>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span>Show details</span>
                    <v-tooltip bottom>                        
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="openSubScreen()">
                                <v-icon>mdi-open-in-app</v-icon>
                            </v-btn>
                        </template>
                        <span tyle="text-align: right;">Show me more...</span>
                    </v-tooltip>
                </v-card-actions>
            </v-container>
        </v-card>
        <reviewDetails ref="reviewDetails"></reviewDetails>
    </div>
</template>
<script>

    import {bus} from "../../../../main";
    import reviewDetails from "./revDetails.vue";

    export default {
        components: {
            reviewDetails,
        },    
        computed: {
            switch_label: function () {
                if (this.showAll) {
                    return "show raw average";
                } else {
                    return "show published average";
                }
            },
            current_size: function(){	
                return this.$vuetify.breakpoint.name;
            },  
        },   
        data() {
            return {
                reviews: {},
                showAll: true,
            }
        },
        created() {
            // here we will add the axios call to get the review scores from ares and assign the score
            this.getReviewData();

            bus.$on("refresh", (data) => {
                console.log("refresh received for reviews score card " + data);
                this.getReviewData();
            });            
        },    
        methods: {
            openSubScreen(){
                this.$refs.reviewDetails.open(this.reviews);
            },        
            getSize(){
                //return 300
                if(this.current_size ==="xl"){
                    return 295
                } 
                else {
                    return 235
                }
            },
            getReviewData(){
                //console.log("start review");
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getReviewData.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getReviewData"
                        },
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {                       
                            this.reviews = res.data.getReviewData;
                            //console.log(this.reviews)
                        }
                    })
                    .finally(() => {

                    });
            },        
        }
    }
</script>
<style scoped>
    .score {
        background: lightgreen !important;
        border: 10px solid green;
    }
    .score-text {
        background: transparent !important;
    }
    .flex-col{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .score-parent2 {
        background: url('../assets/salmon_bubble.png') !important;
        background-size: cover !important;
    }
    .av-font {
        font-size: 110px;
        color: green;
    }
    .av-font-xl {
        font-size: 80px;
        color: green;
    }    
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .small-font{
        font-size: 15px;
        font-weight: 600;
    }
    .nrofreviews-font {
        font-size: 22px;
        font-weight: bold;
        color: red;
    }
    .mock-href{
        color: blue;
        cursor: pointer;
    }    
    .br_medium {
        display: block;
        margin-bottom: 1em;
    }    
    .badge{
        display:flex;
        flex-direction: column;
        justify-items: center;
    }
    .room{
        background-color: brown;
        width:fit-content !important;
    }
</style>